<template>
    <div class="slide-title font-vectrex text-uppercase text-4xl lg:text-7xl mb-10 lg:mb-0 px-3 lg:p-12 xl:pr-[300px] line-clamp-3 xl:line-clamp-2">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'AtomTitleOpaque'
}
</script>

<style lang="scss" scoped>
.slide-title {
    -webkit-mask-image: linear-gradient(0deg, transparent 0px, red 66px);
    @media (min-width: 1024px) {
        & {
            -webkit-mask-image: linear-gradient(0deg, transparent 35px, red 170px);
        }
    }
}
</style>
